<template>
  <div class="notification has-text-centered p-4">
    <span class="icon is-large my-4">
      <i class="fas fa-exclamation-triangle fa-7x"></i>
    </span>
    <p class="title my-3">COMING SOON</p>
  </div>
</template>

<script>
export default {
  name: 'About',
};
</script>

<style>

</style>
